import type { MouseEvent } from 'react';
import type React from 'react';
import type { PlacesType } from 'react-tooltip';

interface ButtonProps {
  icon: React.ReactNode;
  tooltipContent?: string;
  tooltipPlace?: PlacesType;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  addStyle?: string;
  isActive?: boolean;
  variant?: 'primary' | 'secondary';
}

const variantStyles = {
  primary:
    'focus-visible:outline-primary shadow-md bg-neutralBG text-[#2f2f2f] hover:bg-[#eaeaed] dark:bg-[#333135] dark:text-neutralBG dark:hover:bg-[#545454]',
  primaryActive: 'bg-primary text-[white] hover:bg-[#5547eb]',
  secondary:
    'bg-transparent dark:text-neutralBG text-neutralText hover:bg-[#ededed]  dark:hover:bg-[#333135]',
  secondaryActive:
    'bg-[#ededed] dark:text-neutralBG text-neutralText dark:bg-[#333135]',
};

export const IconButton: React.FC<ButtonProps> = ({
  icon,
  tooltipContent = '',
  tooltipPlace = 'bottom',
  onClick,
  disabled,
  addStyle,
  isActive,
  variant = 'primary',
}) => {
  return (
    <button
      onKeyDown={(e) => {
        (e.target as HTMLElement).blur();
      }}
      disabled={disabled}
      onClick={onClick}
      data-tooltip-content={tooltipContent}
      data-tooltip-id="tooltip"
      data-tooltip-place={tooltipPlace}
      data-tooltip-delay-show={100}
      data-tooltip-offset={0}
      className={`${
        isActive
          ? variantStyles[`${variant}Active`]
          : variantStyles[`${variant}`]
      } h-9 rounded-md px-3 text-sm outline-none outline-offset-0 transition-all duration-300 ease-in-out ${addStyle}`}
    >
      {icon}
    </button>
  );
};
